__turbopack_context__.v({
  "backgroundMedia": "full-width-media-module__1dQz8W__backgroundMedia",
  "wrapper": "full-width-media-module__1dQz8W__wrapper",
});
